import * as React from "react";
import {Button} from "react-bootstrap";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {LcdIcon} from "../common/ui/icon/LcdIcon";
import {BatchUpdateDialog} from "./BatchUpdateDialog";

export interface BatchUpdateButtonOwnProps {
  dataId: string;
  refreshData?: () => void;
}

type BatchUpdateButtonProps = BatchUpdateButtonOwnProps & InjectedIntlProps;

interface BatchUpdateButtonState {
  showDialog: boolean;
}

class BatchUpdateButtonComponent extends React.Component<BatchUpdateButtonProps, BatchUpdateButtonState> {

  constructor(props: BatchUpdateButtonProps) {
    super(props);

    this.state = {
      showDialog: false,
    };
  }

  render() {
    const {dataId, refreshData} = this.props;
    const {showDialog} = this.state;

    return (
        <React.Fragment>
          <Button key="batch-update-button" data-cy="batch-update-button" onClick={this.openDialog}>
            <LcdIcon icon="pencil-square"/>
            <FormattedMessage id="studio.data.data-detail-page.batch-update" defaultMessage="Batch update"/>
          </Button>
          {showDialog && <BatchUpdateDialog dataId={dataId} closeDialog={this.closeDialog} refreshData={refreshData}/>}
        </React.Fragment>
    );
  }

  openDialog = () => {
    this.setState({
      showDialog: true,
    });
  };

  closeDialog = () => {
    this.setState({showDialog: false});
  };
}

export const BatchUpdateButton = injectIntl(BatchUpdateButtonComponent);